import { render } from "./GeGHS.vue?vue&type=template&id=77f52534"
import script from "./GeGHS.vue?vue&type=script&lang=js"
export * from "./GeGHS.vue?vue&type=script&lang=js"

import "./GeGHS.vue?vue&type=style&index=0&id=77f52534&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__